/* Gemstone Well · Elixir Set product page (ported from the prototype's premium.js + clarity.js).
   Prices come from the product's variants; 2/3-bottle prices use the per-bottle discounts set in the
   section (they mirror the store's automatic discounts). Add to cart posts real variants to /cart/add.js. */
(function () {
  const dataEl = document.getElementById('gwProductData');
  if (!dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  const $ = (s) => document.querySelector(s);
  const STONES = D.stones.filter((s) => s.variant);
  if (!STONES.length) return;
  const byId = (id) => STONES.find((s) => s.id === id) || STONES[0];
  const avail = STONES.filter((s) => s.available);
  const first = (avail[0] || STONES[0]).id;
  const second = (avail[1] || avail[0] || STONES[0]).id;
  const state = { bundle: +D.defaultBundle || 2, picks: [first, second, first], active: 0, guide: first };
  const money = (c) => '$' + (c / 100).toFixed(2);
  const unit = () => byId(state.picks[0]).price;
  const total = (n) => STONES.length && state.picks.slice(0, n).reduce((a, id) => a + byId(id).price, 0) - (D.off[n] || 0) * n;
  const compare = (n) => state.picks.slice(0, n).reduce((a, id) => a + (byId(id).compare || byId(id).price), 0);
  const slot = () => (state.bundle === 1 ? 0 : state.active);
  const ctaLabel = () => (state.bundle === 1 ? 'Add to cart' : `Add ${state.bundle} bottles`);

  /* ---------- gallery (clarity.js) ---------- */
  const stage = $('#stage');
  const thumbs = [...document.querySelectorAll('#clThumbs .thumb')];
  const slides = stage ? [...stage.querySelectorAll('.cl-slide')] : [];
  let cur = 0;
  function show(n) {
    if (!slides.length) return;
    cur = (n + slides.length) % slides.length;
    slides.forEach((s, i) => {
      s.classList.toggle('on', i === cur); s.setAttribute('aria-hidden', String(i !== cur));
      const v = s.querySelector('video'); if (v) { if (i === cur) v.play().catch(() => {}); else v.pause(); }
    });
    thumbs.forEach((t, i) => { t.classList.toggle('on', i === cur); t.setAttribute('aria-current', String(i === cur)); });
    const c = $('#clCount'); if (c) c.textContent = `${cur + 1} / ${slides.length}`;
    const t = thumbs[cur]; if (t) { const row = t.parentElement; if (row.scrollWidth > row.clientWidth) row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' }); }
  }
  if (stage) {
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    $('#clPrev').addEventListener('click', () => show(cur - 1));
    $('#clNext').addEventListener('click', () => show(cur + 1));
    stage.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') show(cur - 1); if (e.key === 'ArrowRight') show(cur + 1); });
    let x0 = null, y0 = 0;
    stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });
    document.querySelectorAll('.cl-st').forEach((b) => b.addEventListener('click', () => fill(b.dataset.id)));
  }
  function mirror() {
    const s = byId(state.picks[slot()]);
    const solo = $('#clSolo'), tSolo = $('#clSoloThumb'), cap = $('#clSoloCap');
    if (s.bottle) { if (solo) { solo.src = s.bottle; solo.removeAttribute('srcset'); } if (tSolo) { tSolo.src = s.bottle; tSolo.removeAttribute('srcset'); } }
    if (solo) solo.alt = `Elixir2Go crystal water bottle with ${s.name} and Clear Quartz in the lower chamber`;
    if (cap) cap.textContent = `${s.intention} · ${s.name} & Clear Quartz`;
    document.querySelectorAll('.cl-st').forEach((b) => b.classList.toggle('on', b.dataset.id === s.id));
  }

  /* ---------- stones + bundles ---------- */
  const picker = $('#stonePicker');
  picker.querySelectorAll('.stone').forEach((b) => {
    const s = STONES.find((x) => x.id === b.dataset.id);
    if (!s || !s.available) { b.classList.add('sold'); b.disabled = true; b.setAttribute('aria-disabled', 'true'); const ck = b.querySelector('.ck'); if (ck) ck.outerHTML = '<span class="so">Sold out</span>'; }
  });
  picker.addEventListener('click', (e) => { const b = e.target.closest('.stone'); if (b && !b.disabled) fill(b.dataset.id); });
  function fill(id) { if (!byId(id).available) return; state.picks[slot()] = id; sync(); }

  const OPTS = STONES.map((s) => `<option value="${s.id}"${s.available ? '' : ' disabled'}>${s.intention}${s.available ? '' : ' — sold out'}</option>`).join('');
  function renderPicks() {
    const n = state.bundle; if (n === 1) return;
    const picks = $('#picks'); picks.style.gridTemplateColumns = `repeat(${n},minmax(0,1fr))`;
    picks.innerHTML = Array.from({ length: n }, (_, i) => { const s = byId(state.picks[i]); const role = (D.roles[n] || [])[i] || ''; return `<label class="pick${i === state.active ? ' on' : ''}" data-i="${i}"><span class="pk-l">Bottle ${i + 1}${role ? ` · <em>${role.trim()}</em>` : ''}</span><span class="pk-v"><i style="background:${s.color}"></i><select data-i="${i}" aria-label="Bottle ${i + 1} intention">${OPTS}</select><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></span></label>`; }).join('');
    picks.querySelectorAll('select').forEach((sel) => { sel.value = state.picks[+sel.dataset.i]; });
  }
  $('#picks').addEventListener('change', (e) => { const i = +e.target.dataset.i; state.picks[i] = e.target.value; state.active = i; sync(); });
  const activate = (e) => { const p = e.target.closest('.pick'); if (p && +p.dataset.i !== state.active) { state.active = +p.dataset.i; sync(); } };
  $('#picks').addEventListener('focusin', activate); $('#picks').addEventListener('pointerdown', activate);
  $('#sameBtn').onclick = () => { state.picks = state.picks.map(() => state.picks[0]); sync(); };

  $('#bundles').addEventListener('click', (e) => { const b = e.target.closest('.bundle'); if (b) setBundle(+b.dataset.b); });
  function setBundle(n) {
    const prev = state.bundle; state.bundle = n; if (n > prev) state.active = prev; if (state.active > n - 1) state.active = n - 1;
    document.querySelectorAll('.bundle').forEach((x) => x.classList.toggle('on', +x.dataset.b === n));
    $('#multi').hidden = n === 1;
    $('#multiLabel').textContent = `Choose your intentions (${n} bottles)`;
    $('#multiNote').textContent = D.notes[n] || '';
    $('#sameTxt').textContent = n === 2 ? 'Same intention for both' : 'Same intention for all';
    $('#inboxTxt').textContent = n === 1 ? D.inbox.one : String(D.inbox.many).replace(/\[n\]/g, n);
    renderPicks(); sync();
  }
  function bundleCards() {
    document.querySelectorAll('.bundle').forEach((b) => {
      const n = +b.dataset.b, p = unit() * n - (D.off[n] || 0) * n, c = (byId(state.picks[0]).compare || unit()) * n;
      b.querySelector('[data-p]').innerHTML = `${money(p)}${c > p ? ` <s>${money(c)}</s>` : ''}`;
      b.querySelector('[data-pe]').innerHTML = `${money(p / n)} <small>each</small>`;
      const sv = b.querySelector('[data-sv]'); sv.textContent = c > p ? `Save ${money(c - p).replace('.00', '')}` : ''; sv.hidden = !(c > p);
    });
  }
  function mixLabel() {
    const n = state.bundle, counts = {};
    state.picks.slice(0, n).forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
    const k = Object.keys(counts);
    if (n === 3 && k.length === 3) return '3 intentions';
    return k.map((id) => byId(id).intention + (counts[id] > 1 ? ` ×${counts[id]}` : '')).join(' + ');
  }
  function syncPrice() {
    const n = state.bundle, t = total(n), c = compare(n), s0 = byId(state.picks[0]);
    $('#price').textContent = money(t);
    $('#compare').textContent = money(c); $('#compare').hidden = !(c > t);
    $('#saveChip').textContent = `Save ${money(c - t).replace('.00', '')}`; $('#saveChip').hidden = !(c > t);
    const each = $('#each'); each.hidden = n === 1; each.textContent = `${money(t / n)} each`;
    $('#valueline').textContent = n === 1 ? `${s0.name}${s0.name.includes('&') ? ', paired with' : ' &'} Clear Quartz · ${s0.intention}` : `${mixLabel()} · ${n}-bottle set`;
  }
  function syncSticky() {
    const n = state.bundle, s0 = byId(state.picks[0]), t = total(n), c = compare(n);
    $('#stickyTitle').textContent = n === 1 ? `${s0.name} · ${s0.intention}` : `${mixLabel()} · ${n} bottles`;
    $('#stickyLine').textContent = c > t ? `${money(t)} · Save ${money(c - t).replace('.00', '')}` : money(t);
    const nb = $('#stickyN'); nb.hidden = n === 1; nb.textContent = '×' + n;
    const sb = $('#sticky'); if (!sb.classList.contains('added')) sb.querySelector('.btn span').textContent = ctaLabel();
    if (s0.chamber) { $('#stickyImg').src = s0.chamber; $('#toastImg').src = s0.chamber; }
  }
  function sync() {
    const n = state.bundle; const curS = byId(state.picks[slot()]);
    picker.querySelectorAll('.stone').forEach((b) => b.classList.toggle('on', b.dataset.id === curS.id));
    $('#stoneName').textContent = n === 1 ? curS.name : `Bottle ${state.active + 1} · ${curS.name}`;
    $('#picks').querySelectorAll('.pick').forEach((p) => {
      const i = +p.dataset.i, sel = p.querySelector('select');
      p.classList.toggle('on', i === state.active);
      if (sel.value !== state.picks[i]) sel.value = state.picks[i];
      p.querySelector('.pk-v > i').style.background = byId(state.picks[i]).color;
    });
    bundleCards(); syncPrice(); syncSticky(); syncAddon(); mirror(); renderPanel();
  }

  /* ---------- add-on gemstone set ---------- */
  const aoChk = $('#addonChk'), aoSel = $('#addonSel');
  let aoTouched = false;
  if (aoSel) aoSel.innerHTML = STONES.filter((s) => s.addon && s.addonAvailable).map((s) => `<option value="${s.id}">${s.intention} — ${s.name}</option>`).join('');
  const aoSuggest = () => { const used = state.picks.slice(0, state.bundle); return (STONES.find((s) => s.addon && s.addonAvailable && !used.includes(s.id)) || STONES.find((s) => s.addon) || STONES[0]).id; };
  function syncAddon() {
    if (!aoChk) { const t = $('#addTxt'); if (t) t.textContent = ctaLabel(); return; }
    if (!aoTouched) aoSel.value = aoSuggest();
    const ao = byId(aoSel.value), extra = state.bundle === 1 ? 'a second' : 'an extra';
    $('#aoTitle').textContent = `Add ${extra} intention`;
    if (ao) { if (ao.thumb) $('#aoImg').src = ao.thumb; $('#aoImg').alt = `${ao.intention} gemstone set: ${ao.name} and Clear Quartz`; $('#aoSub').innerHTML = (aoChk.checked ? `Adding <strong>${ao.intention}</strong>: ` : `Try <strong>${ao.intention}</strong> next: `) + `${ao.name} + Clear Quartz. Switch stones in seconds. No second bottle needed.`; }
    $('#aoPick').hidden = !aoChk.checked; $('#addon').classList.toggle('on', aoChk.checked);
    const line = $('#addonLine'); line.hidden = !aoChk.checked;
    if (aoChk.checked) line.innerHTML = `+ ${ao.intention} gemstone set · ${money(D.addonPrice)} &nbsp;·&nbsp; Total <b>${money(total(state.bundle) + D.addonPrice)}</b>`;
    $('#addTxt').textContent = ctaLabel() + (aoChk.checked ? (state.bundle === 1 ? ' + 2nd set' : ' + extra set') : '');
  }
  if (aoChk) { aoChk.addEventListener('change', syncAddon); aoSel.addEventListener('change', () => { aoTouched = true; syncAddon(); }); }

  /* ---------- cart ---------- */
  function items() {
    const counts = {};
    state.picks.slice(0, state.bundle).forEach((id) => { const v = byId(id).variant; counts[v] = (counts[v] || 0) + 1; });
    const list = Object.keys(counts).map((v) => ({ id: +v, quantity: counts[v] }));
    if (aoChk && aoChk.checked) { const a = byId(aoSel.value).addon; if (a) list.push({ id: a, quantity: 1 }); }
    return list;
  }
  function setCount(n) {
    let b = document.getElementById('cartCount');
    const btn = document.querySelector('.cart-btn');
    if (!b && btn) { b = document.createElement('span'); b.className = 'badge'; b.id = 'cartCount'; btn.appendChild(b); }
    if (b) { b.textContent = n; b.classList.add('on'); }
  }
  let busy = false, toastT;
  async function add(goCheckout) {
    if (busy) return; busy = true;
    const err = $('#cartErr'); err.hidden = true;
    const btns = [$('#addBtn'), $('#stickyAdd')]; btns.forEach((b) => b && b.setAttribute('aria-busy', 'true'));
    try {
      const r = await fetch((window.GW && GW.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items() }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
      if (goCheckout) { location.href = '/checkout'; return; }
      const cart = await fetch('/cart.js').then((x) => x.json()); setCount(cart.item_count);
      if (window.GWCart) { GWCart.open(cart); const sb0 = $('#sticky'); sb0.classList.add('added'); setTimeout(() => sb0.classList.remove('added'), 1800); return; }
      const s0 = byId(state.picks[0]);
      $('#toastLine').textContent = `${s0.name} · ${state.bundle === 1 ? s0.intention : state.picks.slice(0, state.bundle).map((id) => byId(id).intention).join(' + ')} · ×${state.bundle}` + (aoChk && aoChk.checked ? ` · + ${byId(aoSel.value).intention} gemstone set` : '');
      const tb = $('#aoToast');
      if (tb) {
        if (aoChk && !aoChk.checked && byId(aoSuggest()).addon) { const id = aoSuggest(); tb.hidden = false; tb.disabled = false; tb.dataset.id = id; tb.innerHTML = `<i data-lucide="plus"></i> Add a ${byId(id).intention} gemstone set · ${money(D.addonPrice)}`; }
        else tb.hidden = true;
      }
      const t = $('#toast'); t.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 6000);
      const sb = $('#sticky'); sb.classList.add('added'); sb.querySelector('.btn span').textContent = 'Added ✓';
      setTimeout(() => { sb.classList.remove('added'); sb.querySelector('.btn span').textContent = ctaLabel(); }, 1800);
      if (window.lucide) lucide.createIcons();
    } catch (e) {
      err.textContent = e.message; err.hidden = false;
    } finally { busy = false; btns.forEach((b) => b && b.removeAttribute('aria-busy')); }
  }
  $('#addBtn').onclick = () => add(false);
  $('#stickyAdd').onclick = () => add(false);
  $('#buyNow').onclick = (e) => { e.preventDefault(); add(true); };
  const aoToast = $('#aoToast');
  if (aoToast) aoToast.onclick = async (e) => {
    const b = e.currentTarget, s = byId(b.dataset.id); if (!s.addon) return;
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: s.addon, quantity: 1 }] }) });
    if (r.ok) { const cart = await fetch('/cart.js').then((x) => x.json()); setCount(cart.item_count); $('#toastLine').textContent += ` · + ${s.intention} gemstone set`; b.innerHTML = '<i data-lucide="check"></i> Gemstone set added'; b.disabled = true; if (window.lucide) lucide.createIcons(); }
  };
  $('#toastClose').onclick = () => $('#toast').classList.remove('show');
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $('#toast').classList.remove('show'); });

  /* ---------- sticky bar + CTA gradient ---------- */
  const sticky = $('#sticky'), addBtn = $('#addBtn');
  function onScroll() {
    const footer = document.querySelector('footer.bw, .foot');
    const past = addBtn.getBoundingClientRect().bottom < 0;
    const atFoot = footer ? footer.getBoundingClientRect().top < window.innerHeight - 40 : false;
    const show = past && !atFoot;
    sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', String(!show));
    const cta = document.querySelector('.cta'); if (cta) { const r = cta.getBoundingClientRect(); const p = Math.min(1, Math.max(0, (window.innerHeight - r.top) / (window.innerHeight + r.height))); cta.style.setProperty('--gp', (p * 100).toFixed(1) + '%'); }
  }
  window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll);

  /* ---------- stone guide panel (gwx-stone-guide section) ---------- */
  function renderPanel() {
    const panel = $('#panel'); if (!panel) return;
    const s = byId(state.guide);
    const btn = s.available ? `<button class="btn btn-ghost" data-choose="${s.id}" type="button">Choose ${s.intention}${state.bundle > 1 ? ` for Bottle ${state.active + 1}` : ''}</button>` : `<button class="btn btn-ghost" disabled>${s.intention} · sold out</button>`;
    panel.innerHTML = `<div class="vis">${s.bottle ? `<img src="${s.bottle}" alt="${s.name} Elixir2Go">` : ''}${s.chamber ? `<img src="${s.chamber}" alt="${s.name} gem chamber">` : ''}</div>
      <div class="txt" key="${s.id}"><span class="eyebrow">${s.intention}</span><h3>${s.name} <span class="script" style="font-size:1.3em">${s.forLine}</span></h3>
      <p style="margin:0;color:var(--grey-600)">${panel.dataset.pairing || ''}</p>
      <div class="pills">${s.benefits.map((b) => `<span>${b.trim()}</span>`).join('')}</div>
      <div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:6px">${btn}</div></div>`;
    document.querySelectorAll('#tabs .tab').forEach((t) => t.classList.toggle('on', t.dataset.id === state.guide));
  }
  const tabs = $('#tabs');
  if (tabs && !tabs.children.length) tabs.innerHTML = STONES.map((s) => `<button class="tab" data-id="${s.id}" type="button">${s.thumb || s.chamber ? `<img src="${s.thumb || s.chamber}" alt="" loading="lazy">` : ''}<span>${s.intention}</span></button>`).join('');
  if (tabs) tabs.addEventListener('click', (e) => { const b = e.target.closest('.tab'); if (b) { state.guide = b.dataset.id; renderPanel(); } });
  const panelEl = $('#panel');
  if (panelEl) panelEl.addEventListener('click', (e) => {
    const b = e.target.closest('[data-choose]'); if (!b) return;
    const filled = slot(); fill(b.dataset.choose);
    window.scrollTo({ top: Math.max(0, picker.getBoundingClientRect().top + window.scrollY - 150), behavior: 'smooth' });
    [picker.querySelector('.stone.on'), state.bundle > 1 ? $('#picks').querySelector(`.pick[data-i="${filled}"]`) : null].filter(Boolean)
      .forEach((t) => { t.classList.remove('flash'); void t.offsetWidth; t.classList.add('flash'); setTimeout(() => t.classList.remove('flash'), 2200); });
  });

  /* CTA buttons (gwx/gw cta section): jump to a bundle */
  const toBuy = (n) => (e) => { e.preventDefault(); setBundle(n); window.scrollTo({ top: Math.max(0, $('#bundles').getBoundingClientRect().top + window.scrollY - 220), behavior: 'smooth' }); const card = document.querySelector(`.bundle[data-b="${n}"]`); card.classList.remove('flash'); void card.offsetWidth; card.classList.add('flash'); setTimeout(() => card.classList.remove('flash'), 2200); };
  const cs = document.getElementById('ctaShop'), co = document.getElementById('ctaOne');
  if (cs) cs.onclick = toBuy(2); if (co) co.onclick = toBuy(1);

  /* ---------- start: ?bundle=2&stones=love,manifest ---------- */
  const q = new URLSearchParams(location.search);
  const qb = +q.get('bundle');
  const qs = (q.get('stones') || '').split(',').filter((id) => STONES.some((s) => s.id === id && s.available));
  if (qs.length) { qs.slice(0, 3).forEach((id, i) => { state.picks[i] = id; }); state.guide = qs[0]; }
  setBundle([1, 2, 3].includes(qb) ? qb : state.bundle);
  show(0); onScroll();
  if (window.lucide) lucide.createIcons();
})();
